import {
  catchErrorInto,
  effect,
  Entity,
  exhaustMapSwitchUntilChanged,
  fromPromise,
  LiveData,
  onComplete,
  onStart,
  smartRetry,
} from '@toeverything/infra';
import { map, tap } from 'rxjs';

import type { AuthService } from '../services/auth';
import type { ServerService } from '../services/server';
import type { UserCreditsDetailStore } from '../stores/user-credits-detail';
import { CreditsMap, CreditsType } from '../server/type/credits';

type CreditsData = {
  effective: number;
  total: number;
};
export type CreditsItem = {
  type: string;
  effective: number;
  total: number;
};
type CreditsList = Array<CreditsItem>;

export class UserCreditsDetail extends Entity {
  credits$ = new LiveData<CreditsData>({ effective: 0, total: 0 });
  creditsList$ = new LiveData<CreditsList>([]);
  dailyCredits$ = new LiveData<CreditsData>({ effective: 0, total: 0 });

  isRevalidating$ = new LiveData(false);
  error$ = new LiveData<any | null>(null);

  constructor(
    private readonly authService: AuthService,
    private readonly store: UserCreditsDetailStore,
    private readonly serverService: ServerService
  ) {
    super();
  }

  revalidate = effect(
    map(() => ({
      accountId: this.authService.session.account$.value?.id,
    })),
    exhaustMapSwitchUntilChanged(
      (a, b) => a.accountId === b.accountId,
      ({ accountId }) =>
        fromPromise(async signal => {
          if (!accountId) {
            return; // no quota if no user
          }
          let creditsRes = null;

          creditsRes = await this.store.fetchUserCreditsDetail();
          return creditsRes;
        }).pipe(
          smartRetry(),
          tap(res => {
            if (res?.data && !res?.data.errorcode) {
              const { balances, totalEffective, totalAvailable } = res.data;
              this.credits$.next({
                effective: Number(totalEffective) || 0,
                total: Number(totalAvailable) || 0,
              });

              this.dailyCredits$.next({
                effective: Number(balances?.DAILY?.effective) || 0,
                total: Number(balances?.DAILY?.amount) || 0,
              });
              let newCreditsList = [
                {
                  type: CreditsMap.EVENT,
                  effective: Number(balances?.EVENT?.effective) || 0,
                  total: Number(balances?.EVENT?.amount) || 0,
                },
                {
                  type: CreditsMap.MONTHLY,
                  effective: Number(balances?.MONTHLY?.effective) || 0,
                  total: Number(balances?.MONTHLY?.amount) || 0,
                },
                {
                  type: CreditsMap.FREE,
                  effective: Number(balances?.FREE?.effective) || 0,
                  total: Number(balances?.FREE?.amount) || 0,
                },
                {
                  type: CreditsMap.ADDON,
                  effective: Number(balances?.ADDON?.effective) || 0,
                  total: Number(balances?.ADDON?.amount) || 0,
                },
                {
                  type: CreditsMap.LIABILTY,
                  effective: Number(balances?.LIABILTY?.effective) || 0,
                  total: Number(balances?.LIABILTY?.amount) || 0,
                },
              ];
              this.creditsList$.next(newCreditsList);
            }
            // if (data) {
            //   const { limit, used } = data;
            //   this.copilotActionUsed$.next(used);
            //   this.copilotActionLimit$.next(
            //     limit === null ? 'unlimited' : limit
            //   ); // fix me: unlimited status
            // } else {
            //   this.copilotActionUsed$.next(null);
            //   this.copilotActionLimit$.next(null);
            // }
          }),
          catchErrorInto(this.error$),
          onStart(() => this.isRevalidating$.next(true)),
          onComplete(() => this.isRevalidating$.next(false))
        ),
      () => {
        // Reset the state when the user is changed
        this.reset();
      }
    )
  );

  reset() {
    // this.copilotActionUsed$.next(null);
    // this.copilotActionLimit$.next(null);
    this.error$.next(null);
    this.isRevalidating$.next(false);
  }

  async fetchTransactionsList(params: { page: number; pageSize: number }) {
    const res = await this.store.fetchTransactionsList(params);
    console.log('aaaaaaTransactionsListres', res);
    return res;
  }

  override dispose(): void {
    this.revalidate.unsubscribe();
  }
}
